import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { CommonModule } from '@angular/common';
import { SharedPaymentModule } from '@arc/unified-payments-frontend/shared-payment';
import { btPayReducers } from './reducers/btpay.reducers';
import { PayEffects } from './effects/btpay.effects';
import { BtPayPaymentAccountsEffects } from './effects/btpay-payment-accounts.effects';
import { BtPayPaymentInformationEffects } from './effects/btpay-payment-information.effects';
import { BtPaySessionEffects } from './effects/btpay-session.effects';

@NgModule({
  imports: [
    CommonModule,
    SharedPaymentModule,
    StoreModule.forFeature('btpay', btPayReducers),
    EffectsModule.forFeature([
      PayEffects,
      BtPayPaymentAccountsEffects,
      BtPayPaymentInformationEffects,
      BtPaySessionEffects,
    ]),
  ],
  exports: [],
})
export class BtPayStoreModule {}
